@if (data.length > 0) {
    <mat-card appearance="elevated" class="table-container">
        <mat-card-content>
            <table mat-table [dataSource]="data">

                @for (column of columnsInfo; track $index) {
                    <ng-container matColumnDef="{{column.columnNameDef}}">
                        @if (column.sortable === true) {
                            <th [ngClass]="{'text-one-line': column?.labelOnOneLine}"
                                class="text-one-line label-large"
                                mat-header-cell *matHeaderCellDef
                                (click)="handleMultiSortEvent(column.columnNameDef)">
                                <div class="table-header">
                                    {{column.label}}
                                    @if (isColumnSorted(column.columnNameDef)) {
                                        @if (getSortDirection(column.columnNameDef) === 'asc') {
                                            <i class="fa-regular fa-arrow-up sort-custom-arrow"></i>
                                        }
                                        @if (getSortDirection(column.columnNameDef) === 'desc') {
                                            <i class="fa-regular fa-arrow-down sort-custom-arrow"></i>
                                        }
                                    } @else {
                                        <i class="fa-regular fa-arrow-down-arrow-up sort-custom-arrow"></i>
                                    }
                                </div>
                            </th>
                        } @else {
                            <th [ngClass]="{'text-one-line': column?.labelOnOneLine}"
                                class="label-large"
                                mat-header-cell *matHeaderCellDef>
                                {{column.label}}
                            </th>
                        }

                        <td mat-cell *matCellDef="let element"
                            [class.cell-component]="column.type === TypeOfColumn.COMPONENT"
                            [class.cell-text]="column.type !== TypeOfColumn.COMPONENT"
                            [class.cell-currency]="column.type === TypeOfColumn.CURRENCY"
                            [ngClass]="column.cellClass ? column.cellClass(element) : ''">
                            @if (column.type === TypeOfColumn.TEXT) {
                                <span class="cell-clamp-4">{{ element[column.columnNameDef] }}</span>
                            } @else if (column.type === TypeOfColumn.DATE) {
                                <div>{{ (element[column.columnNameDef] | date: 'dd/MM/yyyy HH:mm' : 'UTC') || '-' }}</div>
                            } @else if (column.type === TypeOfColumn.NUMBER) {
                                {{ element[column.columnNameDef] | translocoDecimal : {
                                    useGrouping: true,
                                    minimumFractionDigits: column.minimumFractionDigits,
                                    maximumFractionDigits: column.maximumFractionDigits
                                } }}
                            } @else if (column.type === TypeOfColumn.COMPONENT) {
                                <ng-component *ngComponentOutlet="column.component; inputs: { itemData: element, infoColumn: column, _reloadData: reloadDataEmitter }" />
                            } @else if (column.type === TypeOfColumn.CURRENCY) {
                                {{ element[column.columnNameDef] | translocoCurrency: 'symbol' : {
                                    useGrouping: true,
                                    minimumFractionDigits: column.minimumFractionDigits,
                                    maximumFractionDigits: column.maximumFractionDigits
                                } }}
                            } @else if (column.type === TypeOfColumn.DETAIL) {
                                <i class="fa-regular fa-chevron-right"></i>
                            }
                        </td>
                    </ng-container>
                }

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let item; columns: displayedColumns;" (click)="handleRowClicked(item)"></tr>
            </table>
        </mat-card-content>
    </mat-card>
} @else {
    <span class="title-small empty-message-container">Nessun risultato presente</span>
}
